import { usePortalPermissions } from './usePortalPermissions';

export const usePIIRedaction = () => {
  const { permissions } = usePortalPermissions();

  return {
    redact: permissions?.includes('pii.redaction') ?? false,
  };
};
